module.exports = __webpack_public_path__ + "img/5.0da47d63.jpg";